export enum THEME {
    DARK = 'DARK',
    LIGHT = 'LIGHT'
}

export type Theme = THEME | 'SYSTEM';
